// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const MsSqlIcon = createSvgIcon(
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24">
    <g clipPath="url(#ms-sql_svga)">
      <mask
        id="ms-sql_svgb"
        width={20}
        height={20}
        x={2}
        y={2}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path fill="#fff" d="M22 2H2v20h20z" />
      </mask>
      <g mask="url(#ms-sql_svgb)">
        <path
          fill="url(#ms-sql_svgc)"
          d="M12 16c4.42 0 8 1.34 8 3v-6c0-1.66-3.58-3-8-3h-2v6z"
        />
        <path
          fill="url(#ms-sql_svgd)"
          d="M20 13c0 1.66-3.58 3-8 3-2.7 0-5.08-.5-6.53-1.27-.78-.34-1.47.18-1.47.9V19c0 1.66 3.58 3 8 3s8-1.34 8-3z"
        />
        <path
          fill="url(#ms-sql_svge)"
          d="M20 13c0 1.66-3.58 3-8 3-2.7 0-5.08-.5-6.53-1.27-.78-.34-1.47.18-1.47.9V19c0 1.66 3.58 3 8 3s8-1.34 8-3z"
        />
        <path
          fill="url(#ms-sql_svgf)"
          d="M12 2c4.42 0 8 1.34 8 3v3.4c0 .46-.48 1.28-1.47.86C17.08 8.5 14.69 8 12 8c-4.42 0-8 1.34-8 3V5c0-1.66 3.58-3 8-3"
        />
        <path
          fill="url(#ms-sql_svgg)"
          d="M12 8C7.58 8 4 6.66 4 5v6c0 1.66 3.58 3 8 3h.5c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5z"
        />
        <path
          fill="url(#ms-sql_svgh)"
          d="M12 8C7.58 8 4 6.66 4 5v6c0 1.66 3.58 3 8 3h.5c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5z"
        />
      </g>
    </g>
    <defs>
      <radialGradient
        id="ms-sql_svgd"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(143.59 5.65 9.79)scale(12.4254 22.0897)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3BD5FF" />
        <stop offset={1} stopColor="#0078D4" />
      </radialGradient>
      <radialGradient
        id="ms-sql_svge"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(146.31 7.2 9.55)scale(10.8167 18.2483)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DECBFF" stopOpacity={0.9} />
        <stop offset={1} stopColor="#DECBFF" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="ms-sql_svgg"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(-7.5793 6.93786 -10.80657 -11.80571 11.86 7.06)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3BD5FF" />
        <stop offset={1} stopColor="#0078D4" />
      </radialGradient>
      <radialGradient
        id="ms-sql_svgh"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(-7.49997 4.50003 -7.2031 -12.00504 13.5 6.5)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DECBFF" stopOpacity={0.9} />
        <stop offset={1} stopColor="#D1D1FF" stopOpacity={0} />
      </radialGradient>
      <linearGradient
        id="ms-sql_svgc"
        x1={17}
        x2={8.64}
        y1={10}
        y2={16.92}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0094F0" />
        <stop offset={0.24} stopColor="#0078D4" />
        <stop offset={0.58} stopColor="#2052CB" />
        <stop offset={0.83} stopColor="#312A9A" />
      </linearGradient>
      <linearGradient
        id="ms-sql_svgf"
        x1={15.5}
        x2={6.03}
        y1={2.5}
        y2={12.81}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0FAFFF" />
        <stop offset={0.16} stopColor="#0094F0" />
        <stop offset={0.56} stopColor="#2052CB" />
        <stop offset={0.76} stopColor="#312A9A" />
      </linearGradient>
      <clipPath id="ms-sql_svga">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>,
  "MsSql",
);
export default MsSqlIcon;
